import CryptoJS from "@/common/crypto-js.min";
// import CryptoJS from 'crypto-js'

const key = "sunshine";

export default {
  encryptByDES(message) {
    // 加密
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    const encrypted = CryptoJS.DES.encrypt(JSON.stringify(message), keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedParams = {
      bodyContent: encrypted.ciphertext.toString(),
    };
    return encryptedParams;
  },
  decryptByDES(ciphertext) {
    // 解密
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    const decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(ciphertext),
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const result_value = decrypted.toString(CryptoJS.enc.Utf8);
    return result_value;
  },
};
